"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../../data/constants");
var constantsClasses_1 = require("../../data/constantsClasses");
var NavigationElement = /** @class */ (function () {
    function NavigationElement(element) {
        this.element = element;
        if (!this.getElement())
            return;
        this.NavigationItems = this.getElement().querySelectorAll("[".concat(constants_1.DATA_NAVIGATION_ITEM, "]"));
    }
    /**
     * Return HTMLElement of navigation element
     */
    NavigationElement.prototype.getElement = function () {
        var _a;
        return (_a = this.element) !== null && _a !== void 0 ? _a : null;
    };
    /**
     * Close all sub menus of navigation element
     */
    NavigationElement.prototype.closeAllSubMenus = function () {
        this.NavigationItems.forEach(function (element) {
            element.classList.remove(constantsClasses_1.CLASS_ACTIVE);
        });
    };
    return NavigationElement;
}());
exports.default = NavigationElement;
